(function ($) {
	window.FontAwesomeConfig = { autoReplaceSvg: false };
	var email_is_sending = false; // Variable qui permet de controler le clic sur l'envoi des email;
	let $isotope = "";
	var $grid = $(".listing-bonsplans").imagesLoaded(function () {
		$isotope = $(".listing-bonsplans").isotope({
			itemSelector: ".fiche-bon-plan",
			layoutMode: "fitRows",
			getSortData: {
				type: ".hidden-type",
				value: ".hidden-value parseInt",
			},
			sortBy: ["type", "value"],
			sortAscending: false,
		});
	});

	$("window").on("resize", function () {
		initResponsiveMenu();
	});

	$(".user_menu a[title='Deconnexion']").click(function (e) {
		return confirm("Voulez-vous vraiment vous déconnecter ?");
	});

	function init() {
		initResponsiveMenu();
		initSlick();
		initUseCoupon();
		initButtonFilters();
		initFavorites();
		verifFavorites();
		viewGaleries();
		verifStyle();
		initTabs();
		moveSocial();
		initTracking();
		initMobilemenu();
		initNewsletter();
		dlUsers();
		initStars();
		initConcoursFilters();
		initTooltip();
		initSearchBar();
		initSelects();
		new WOW().init();
		initHomepagePub();
		initBuddyPress();
	}

	function initBuddyPress() {
		$(".block .groups .navbar .nav").click(function (e) {
			var el = $(this);
			$(".block .groups .navbar .nav.active").removeClass("active");
			$(".block .groups .onglet.active").removeClass("active");
			el.addClass("active");
			$(".block .groups .onglet." + el.data("target")).addClass("active");
		});
	}

	function getAnchor() {
		return document.URL.split("#").length > 1 ? document.URL.split("#")[1] : null;
	}

	function initHomepagePub() {}

	function initResponsiveMenu() {
		if (window.innerWidth <= 1100) {
			$("#toolboxresp").append($("#selects"));
		} else {
			$("#toolbox").append($("#selects"));
		}
	}

	function initSelects() {
		// Ouverture des selects
		$(".select").click(function () {
			var el = $(this);
			if (el.hasClass("active")) {
				el.removeClass("active");
			} else {
				el.addClass("active");
			}
		});

		// Récupération de la valeur sur le clic d'un select
		$(".select .options .option").click(function () {
			var el = $(this);
			var value = el.data("name");
			var url = el.data("value");
			var parent = el.closest(".select");

			el.closest(".options").prev(".synthese").attr("data-value", value);

			if (url) {
				el.closest(".options").prev(".synthese").attr("data-url", url);
			}

			el.closest(".options")
				.prev(".synthese")
				.html("Destination " + value + "<span>Validez pour voir les hébergements et les bons plans</span>");

			// if (parent.hasClass("departement")) {
			// 	localStorage.setItem("departement", value);
			// 	var pub = $("#intro");
			// 	var publink = pub.find(".pub-tracking");

			// 	pub.css({ "background-image": "url(" + el.data("pub") + ")" });
			// 	publink.attr("data-campaign", el.data("campaign"));
			// 	publink.attr("href", el.data("link"));
			// }

			$("#target_search").attr("data-url", url);
			$("#target_search_2").attr("data-url", url);
			$("#target_search_mobile").attr("data-url", url);
		});

		// Je cache le menu déroulant au mouseout
		$(".select .options").mouseleave(function () {
			$(this).parent(".select").removeClass("active");
		});

		$("#target_search, #target_search_2, #target_search_mobile").click(function () {
			window.location.href = $(this).data("url");
		});
	}

	function initSearchBar() {
		$(".lunch-search").click(function () {
			if ($("#search").hasClass("active")) {
				$("#search").removeClass("active");
			} else {
				$("#search").addClass("active");
			}
		});
	}

	function initTooltip() {
		$(".fiche-phone").hover(function () {
			var el = $(this);
		});
	}

	function initConcoursFilters() {
		$(".filterconcours .filtre").click(function () {
			var el = $(this);
			var target = el.data("target");
			$(".filterconcours .filtre").removeClass("active");
			$(".listing-concours").removeClass("active");
			$(".listing-concours." + target).addClass("active");
			el.addClass("active");
		});
	}

	function initStars() {
		$("#stars img").click(function () {
			var el = $(this);
			$("#stars img").removeClass("selected");
			el.addClass("selected");
			var position = el.data("note");
			$("#stars").attr("data-note", position);
			for (var i = 0; i < 5; i++) {
				if (i < position) {
					$("#stars i").eq(i).removeClass("fa-star-o").addClass("fa-star");
				} else {
					$("#stars i").eq(i).removeClass("fa-star").addClass("fa-star-o");
				}
			}
		});
		$("#rateetablissement").submit(function (e) {
			e.preventDefault();
			var userid = $("#user_avis").val();
			var etablissementid = $("#etablissement_avis").val();
			var note = $("#stars").data("note");
			var commentaire = $("#message_avis").val();
			$("#rateetablissement").addClass("hidden");
			$("#avis_loading").addClass("visible");
			$.post(
				ajaxurl,
				{
					action: "send_avis",
					userid: userid,
					etablissementid: etablissementid,
					note: note,
					commentaire: commentaire,
				},
				function (response) {
					if (response == "ok") {
						setTimeout(function () {
							$("#avis_loading").removeClass("visible");
							$("#reponse_avis").addClass("visible");
						}, 1500);
					} else {
						$("#rateetablissement").removeClass("hidden");
						$("#avis_loading").removeClass("visible");
					}
				}
			);
		});
		$(".accept_avis").click(function () {
			var id = $(this).data("id");
			var parent = $(this).closest(".result");
			$.post(
				ajaxurl,
				{
					action: "accept_avis",
					id: id,
				},
				function (response) {
					parent.remove();
				}
			);
		});
		$(".delete_avis").click(function () {
			var id = $(this).data("id");
			var parent = $(this).closest(".result");
			$.post(
				ajaxurl,
				{
					action: "delete_avis",
					id: id,
				},
				function (response) {
					parent.remove();
				}
			);
		});
	}

	function dlUsers() {
		$("#download_users").click(function () {
			$.post(
				ajaxurl,
				{
					action: "dl_users",
				},
				function (response) {
					var csvContent = "data:text/csv;charset=utf-8,";
					csvContent += "Email" + "\r\n";
					response.forEach(function (el) {
						csvContent += el + "\r\n";
					});
					var encodedUri = encodeURI(csvContent);
					var link = document.createElement("a");
					link.setAttribute("href", encodedUri);
					link.setAttribute("download", "abonnes.csv");
					document.body.appendChild(link); // Required for FF

					link.click();
				}
			);
		});
	}

	function initNewsletter() {
		$("#inscription_newsletter").submit(function (e) {
			$("#biche").addClass("visible");
			$("#inscription_newsletter").addClass("hidden");
			e.preventDefault();
			var name = $("#newsletter_nom").val();
			var email = $("#newsletter_email").val();

			$.post(
				ajaxurl,
				{
					action: "register_user",
					nom: name,
					email: email,
				},
				function (response) {
					if (response == "ok") {
						setTimeout(function () {
							$("#biche").removeClass("visible");
							$("#reponse").addClass("visible");
						}, 1500);
					} else {
						$("#biche").removeClass("visible");
						$("#inscription_newsletter").removeClass("hidden");
					}
				}
			);
		});
	}

	function initMobilemenu() {
		$("#mobile-menu #barre .hamburger").click(function () {
			var el = $(this);
			if (el.hasClass("is-active")) {
				el.removeClass("is-active");
				el.parent(".menu").removeClass("active");
				$("#menu-content").removeClass("visible");
				$("#mobile-menu").removeClass("expand");
			} else {
				el.addClass("is-active");
				el.parent(".menu").addClass("active");
				$("#menu-content").addClass("visible");
				$("#mobile-menu").addClass("expand");
			}
		});
	}

	function initTracking() {
		$(".pub-tracking").click(function () {
			var el = $(this);
			var campaign = el.data("campaign");
			$.post(
				ajaxurl,
				{
					action: "register_pub",
					campaign: campaign,
				},
				function (response) {
					//
				}
			);
		});
	}

	function moveSocial() {
		var el = $(".wppb-sc-buttons-container").detach();
		$(".firstzone").append(el);
	}

	function initTabs() {
		// Nav vers le bon onglet si la page est accédé depuis une URL
		if ($("#tab1").length) {
			const anchor = getAnchor();

			if (anchor) {
				$(".tab").removeClass("active");
				var el = $("#" + anchor);
				var cibleposition = el.offset();
				el.addClass("active");
				$(".tabcontent").removeClass("active");
				$(".tabcontent" + "#" + anchor).addClass("active");
				$("html, body").animate(
					{
						scrollTop: cibleposition.top - 150 + "px",
					},
					400
				);
			}

			$(".tab.ajx").click(function (e) {
				e.preventDefault();
				$(".tab").removeClass("active");
				var el = $(this);
				var cible = el.attr("href");
				var cibleposition = el.offset();
				el.addClass("active");
				$(".tabcontent").removeClass("active");
				$(".tabcontent" + cible).addClass("active");
				$("html, body").animate(
					{
						scrollTop: cibleposition.top - 150 + "px",
					},
					400
				);
			});
		}
	}

	function verifStyle() {
		if ($("main article").hasClass("restaurants")) {
			$("header").addClass("restaurants");
		} else if ($("main article").hasClass("loisirs")) {
			$("header").addClass("loisirs");
		} else if ($("main article").hasClass("commerces")) {
			$("header").addClass("commerces");
		} else if ($("main article").hasClass("hebergements")) {
			$("header").addClass("hebergements");
		}
	}

	function viewGaleries() {
		$(".view_gallery").click(function () {
			var el = $(this);
			var first = el.find("a.fancies:first");
			first.trigger("click");
		});
	}

	function initButtonFilters() {
		$(".filters li").click(function () {
			var parent = $(this).parents("ul");
			var label = parent.prevAll(".label");
			parent.children("li").each(function () {
				$(this).removeClass("selected");
			});
			$(this).addClass("selected");
			label.text($(this).text());
			setTimeout(function () {
				filter();
			}, 100);
		});
	}

	function filter() {
		var filtre1 = $(".type-filter li.selected").data("cible");
		var filtre2 = $(".type-cat li.selected").data("cible");
		var filtre3 = $(".type-ville li.selected").data("cible");
		var filterValue = "." + filtre1 + "." + filtre2 + "." + filtre3;
		$grid.isotope({ filter: filterValue });
	}

	function initUseCoupon() {
		$("body").on("click", ".use_coupon", function () {
			var el = $("#appli");
			var pos = el.offset();
			$("html, body").animate(
				{
					scrollTop: pos.top + "px",
				},
				400
			);
		});
		$("body").on("click", ".use_bonplan", function () {
			var el = $("#appli");
			var pos = el.offset();
			$("html, body").animate(
				{
					scrollTop: pos.top + "px",
				},
				400
			);
		});
		$("body").on("click", ".connect_to_use_bonplan", function (e) {
			e.preventDefault();
			var el = $("#appli");
			var pos = el.offset();
			$("html, body").animate(
				{
					scrollTop: pos.top + "px",
				},
				400
			);
		});
	}

	function initSlick() {
		$("body.home .last-listing").slick({
			infinite: true,
			speed: 400,
			slidesToShow: 3,
			centerMode: true,
			centerPadding: "50px",
			slidesToScroll: 1,
			autoplay: false,
			prevArrow: '<div class="slick-arrow slick-prev"><i class="fa fa-angle-left"></i></div>',
			nextArrow: '<div class="slick-arrow slick-next"><i class="fa fa-angle-right"></i></div>',
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 1,
						centerMode: false,
					},
				},
				{
					breakpoint: 700,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerMode: false,
						centerPadding: "0px",
					},
				},
			],
		});
	}

	function initFavorites() {
		$(".add_to_favorite").click(function () {
			var el = $(this);
			var bonplan = el.data("bonplan");
			var user = el.data("user");

			if (el.hasClass("already")) {
				$.post(
					ajaxurl,
					{
						action: "remove_from_favorites",
						bonplan: bonplan,
						user: user,
					},
					function (response) {
						el.removeClass("already");
						el.find("i, svg-inline--fa").removeClass("fas animated jello").addClass("fal animated tada");
						el.find("span").html("Ajouter à mes favoris");
						verifFavorites();
					}
				);
			} else {
				$.post(
					ajaxurl,
					{
						action: "add_to_favorites",
						bonplan: bonplan,
						user: user,
					},
					function (response) {
						el.addClass("already");
						el.find("i").removeClass("fal animated tada").addClass("fas animated jello");
						el.find("span").html("Dans vos favoris");
						verifFavorites();
					}
				);
			}
		});
	}

	function verifFavorites() {
		$(".add_to_favorite").each(function () {
			var el = $(this);
			var bonplan = el.data("bonplan");
			var user = el.data("user");

			$.post(
				ajaxurl,
				{
					action: "verif_favorites",
					bonplan: bonplan,
					user: user,
				},
				function (response) {
					console.log(response);
					if (response == "OK") {
						el.addClass("already");
						el.find("i").removeClass("fal animated tada").addClass("fas animated jello");
						el.find("span").html("Dans vos favoris");
					} else {
						el.removeClass("already");
						el.find("i").removeClass("fas animated jello").addClass("fal animated tada");
						el.find("span").html("Ajouter à mes favoris");
					}
				}
			);
		});
	}

	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this,
				args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	}

	let nom_commercant = document.getElementById("etablissement-recherche");

	if (nom_commercant) {
		nom_commercant.addEventListener("keyup", (e) => {
			if (e.target.value.length >= 3) {
				function search() {
					$grid.isotope({
						filter: function () {
							let titre2 = $(this).find(".etablissement").text();
							return titre2
								.toLowerCase()
								.normalize("NFD")
								.replace(/[\u0300-\u036f]/g, "")
								.includes(
									e.target.value
										.toLowerCase()
										.normalize("NFD")
										.replace(/[\u0300-\u036f]/g, "")
								);
						},
					});
				}
				debounce(search(), 1000);
			} else {
				$grid.isotope({
					filter: "*",
				});
			}
		});
	}

	$grid.on("layoutComplete", function (event, filteredItems) {
		if (filteredItems.length < 1) {
			$("#no-results").show();
			$(".listing-bonsplans").css("height", "");
		} else {
			$("#no-results").hide();
		}
	});

	init();
})(jQuery);
